// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__17Y-3","rootSmall":"AddTileButton_rootSmall__BSQWO"};